module.exports = __webpack_public_path__ + "img/collection_on.90210cdc.png";